/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PublicRouteImport } from './routes/_public'
import { Route as ProtectedRouteImport } from './routes/_protected'
import { Route as IndexRouteImport } from './routes/index'
import { Route as PublicLoginRouteImport } from './routes/_public/login'
import { Route as ProtectedZonesRouteImport } from './routes/_protected/zones'
import { Route as ProtectedCategoriesRouteImport } from './routes/_protected/categories'
import { Route as ProtectedWarehousesIndexRouteImport } from './routes/_protected/warehouses/index'
import { Route as ProtectedUsersIndexRouteImport } from './routes/_protected/users/index'
import { Route as ProtectedSuppliersIndexRouteImport } from './routes/_protected/suppliers/index'
import { Route as ProtectedShipmentsIndexRouteImport } from './routes/_protected/shipments/index'
import { Route as ProtectedSellsIndexRouteImport } from './routes/_protected/sells/index'
import { Route as ProtectedClientsIndexRouteImport } from './routes/_protected/clients/index'
import { Route as ProtectedBuysIndexRouteImport } from './routes/_protected/buys/index'
import { Route as ProtectedArticlesIndexRouteImport } from './routes/_protected/articles/index'
import { Route as ProtectedWarehousesIdRouteImport } from './routes/_protected/warehouses/$id'
import { Route as ProtectedUsersIdRouteImport } from './routes/_protected/users/$id'
import { Route as ProtectedSuppliersIdRouteImport } from './routes/_protected/suppliers/$id'
import { Route as ProtectedShipmentsCreateRouteImport } from './routes/_protected/shipments/create'
import { Route as ProtectedShipmentsIdRouteImport } from './routes/_protected/shipments/$id'
import { Route as ProtectedSellsCreateRouteImport } from './routes/_protected/sells/create'
import { Route as ProtectedSellsIdRouteImport } from './routes/_protected/sells/$id'
import { Route as ProtectedClientsIdRouteImport } from './routes/_protected/clients/$id'
import { Route as ProtectedBuysCreateRouteImport } from './routes/_protected/buys/create'
import { Route as ProtectedBuysIdRouteImport } from './routes/_protected/buys/$id'
import { Route as ProtectedArticlesIdRouteImport } from './routes/_protected/articles/$id'

const PublicRoute = PublicRouteImport.update({
  id: '/_public',
  getParentRoute: () => rootRouteImport,
} as any)
const ProtectedRoute = ProtectedRouteImport.update({
  id: '/_protected',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const PublicLoginRoute = PublicLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => PublicRoute,
} as any)
const ProtectedZonesRoute = ProtectedZonesRouteImport.update({
  id: '/zones',
  path: '/zones',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedCategoriesRoute = ProtectedCategoriesRouteImport.update({
  id: '/categories',
  path: '/categories',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedWarehousesIndexRoute =
  ProtectedWarehousesIndexRouteImport.update({
    id: '/warehouses/',
    path: '/warehouses/',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedUsersIndexRoute = ProtectedUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSuppliersIndexRoute = ProtectedSuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedShipmentsIndexRoute = ProtectedShipmentsIndexRouteImport.update({
  id: '/shipments/',
  path: '/shipments/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSellsIndexRoute = ProtectedSellsIndexRouteImport.update({
  id: '/sells/',
  path: '/sells/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedClientsIndexRoute = ProtectedClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedBuysIndexRoute = ProtectedBuysIndexRouteImport.update({
  id: '/buys/',
  path: '/buys/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedArticlesIndexRoute = ProtectedArticlesIndexRouteImport.update({
  id: '/articles/',
  path: '/articles/',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedWarehousesIdRoute = ProtectedWarehousesIdRouteImport.update({
  id: '/warehouses/$id',
  path: '/warehouses/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedUsersIdRoute = ProtectedUsersIdRouteImport.update({
  id: '/users/$id',
  path: '/users/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSuppliersIdRoute = ProtectedSuppliersIdRouteImport.update({
  id: '/suppliers/$id',
  path: '/suppliers/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedShipmentsCreateRoute =
  ProtectedShipmentsCreateRouteImport.update({
    id: '/shipments/create',
    path: '/shipments/create',
    getParentRoute: () => ProtectedRoute,
  } as any)
const ProtectedShipmentsIdRoute = ProtectedShipmentsIdRouteImport.update({
  id: '/shipments/$id',
  path: '/shipments/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSellsCreateRoute = ProtectedSellsCreateRouteImport.update({
  id: '/sells/create',
  path: '/sells/create',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedSellsIdRoute = ProtectedSellsIdRouteImport.update({
  id: '/sells/$id',
  path: '/sells/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedClientsIdRoute = ProtectedClientsIdRouteImport.update({
  id: '/clients/$id',
  path: '/clients/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedBuysCreateRoute = ProtectedBuysCreateRouteImport.update({
  id: '/buys/create',
  path: '/buys/create',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedBuysIdRoute = ProtectedBuysIdRouteImport.update({
  id: '/buys/$id',
  path: '/buys/$id',
  getParentRoute: () => ProtectedRoute,
} as any)
const ProtectedArticlesIdRoute = ProtectedArticlesIdRouteImport.update({
  id: '/articles/$id',
  path: '/articles/$id',
  getParentRoute: () => ProtectedRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/categories': typeof ProtectedCategoriesRoute
  '/zones': typeof ProtectedZonesRoute
  '/login': typeof PublicLoginRoute
  '/articles/$id': typeof ProtectedArticlesIdRoute
  '/buys/$id': typeof ProtectedBuysIdRoute
  '/buys/create': typeof ProtectedBuysCreateRoute
  '/clients/$id': typeof ProtectedClientsIdRoute
  '/sells/$id': typeof ProtectedSellsIdRoute
  '/sells/create': typeof ProtectedSellsCreateRoute
  '/shipments/$id': typeof ProtectedShipmentsIdRoute
  '/shipments/create': typeof ProtectedShipmentsCreateRoute
  '/suppliers/$id': typeof ProtectedSuppliersIdRoute
  '/users/$id': typeof ProtectedUsersIdRoute
  '/warehouses/$id': typeof ProtectedWarehousesIdRoute
  '/articles': typeof ProtectedArticlesIndexRoute
  '/buys': typeof ProtectedBuysIndexRoute
  '/clients': typeof ProtectedClientsIndexRoute
  '/sells': typeof ProtectedSellsIndexRoute
  '/shipments': typeof ProtectedShipmentsIndexRoute
  '/suppliers': typeof ProtectedSuppliersIndexRoute
  '/users': typeof ProtectedUsersIndexRoute
  '/warehouses': typeof ProtectedWarehousesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/categories': typeof ProtectedCategoriesRoute
  '/zones': typeof ProtectedZonesRoute
  '/login': typeof PublicLoginRoute
  '/articles/$id': typeof ProtectedArticlesIdRoute
  '/buys/$id': typeof ProtectedBuysIdRoute
  '/buys/create': typeof ProtectedBuysCreateRoute
  '/clients/$id': typeof ProtectedClientsIdRoute
  '/sells/$id': typeof ProtectedSellsIdRoute
  '/sells/create': typeof ProtectedSellsCreateRoute
  '/shipments/$id': typeof ProtectedShipmentsIdRoute
  '/shipments/create': typeof ProtectedShipmentsCreateRoute
  '/suppliers/$id': typeof ProtectedSuppliersIdRoute
  '/users/$id': typeof ProtectedUsersIdRoute
  '/warehouses/$id': typeof ProtectedWarehousesIdRoute
  '/articles': typeof ProtectedArticlesIndexRoute
  '/buys': typeof ProtectedBuysIndexRoute
  '/clients': typeof ProtectedClientsIndexRoute
  '/sells': typeof ProtectedSellsIndexRoute
  '/shipments': typeof ProtectedShipmentsIndexRoute
  '/suppliers': typeof ProtectedSuppliersIndexRoute
  '/users': typeof ProtectedUsersIndexRoute
  '/warehouses': typeof ProtectedWarehousesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_protected': typeof ProtectedRouteWithChildren
  '/_public': typeof PublicRouteWithChildren
  '/_protected/categories': typeof ProtectedCategoriesRoute
  '/_protected/zones': typeof ProtectedZonesRoute
  '/_public/login': typeof PublicLoginRoute
  '/_protected/articles/$id': typeof ProtectedArticlesIdRoute
  '/_protected/buys/$id': typeof ProtectedBuysIdRoute
  '/_protected/buys/create': typeof ProtectedBuysCreateRoute
  '/_protected/clients/$id': typeof ProtectedClientsIdRoute
  '/_protected/sells/$id': typeof ProtectedSellsIdRoute
  '/_protected/sells/create': typeof ProtectedSellsCreateRoute
  '/_protected/shipments/$id': typeof ProtectedShipmentsIdRoute
  '/_protected/shipments/create': typeof ProtectedShipmentsCreateRoute
  '/_protected/suppliers/$id': typeof ProtectedSuppliersIdRoute
  '/_protected/users/$id': typeof ProtectedUsersIdRoute
  '/_protected/warehouses/$id': typeof ProtectedWarehousesIdRoute
  '/_protected/articles/': typeof ProtectedArticlesIndexRoute
  '/_protected/buys/': typeof ProtectedBuysIndexRoute
  '/_protected/clients/': typeof ProtectedClientsIndexRoute
  '/_protected/sells/': typeof ProtectedSellsIndexRoute
  '/_protected/shipments/': typeof ProtectedShipmentsIndexRoute
  '/_protected/suppliers/': typeof ProtectedSuppliersIndexRoute
  '/_protected/users/': typeof ProtectedUsersIndexRoute
  '/_protected/warehouses/': typeof ProtectedWarehousesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/categories'
    | '/zones'
    | '/login'
    | '/articles/$id'
    | '/buys/$id'
    | '/buys/create'
    | '/clients/$id'
    | '/sells/$id'
    | '/sells/create'
    | '/shipments/$id'
    | '/shipments/create'
    | '/suppliers/$id'
    | '/users/$id'
    | '/warehouses/$id'
    | '/articles'
    | '/buys'
    | '/clients'
    | '/sells'
    | '/shipments'
    | '/suppliers'
    | '/users'
    | '/warehouses'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/categories'
    | '/zones'
    | '/login'
    | '/articles/$id'
    | '/buys/$id'
    | '/buys/create'
    | '/clients/$id'
    | '/sells/$id'
    | '/sells/create'
    | '/shipments/$id'
    | '/shipments/create'
    | '/suppliers/$id'
    | '/users/$id'
    | '/warehouses/$id'
    | '/articles'
    | '/buys'
    | '/clients'
    | '/sells'
    | '/shipments'
    | '/suppliers'
    | '/users'
    | '/warehouses'
  id:
    | '__root__'
    | '/'
    | '/_protected'
    | '/_public'
    | '/_protected/categories'
    | '/_protected/zones'
    | '/_public/login'
    | '/_protected/articles/$id'
    | '/_protected/buys/$id'
    | '/_protected/buys/create'
    | '/_protected/clients/$id'
    | '/_protected/sells/$id'
    | '/_protected/sells/create'
    | '/_protected/shipments/$id'
    | '/_protected/shipments/create'
    | '/_protected/suppliers/$id'
    | '/_protected/users/$id'
    | '/_protected/warehouses/$id'
    | '/_protected/articles/'
    | '/_protected/buys/'
    | '/_protected/clients/'
    | '/_protected/sells/'
    | '/_protected/shipments/'
    | '/_protected/suppliers/'
    | '/_protected/users/'
    | '/_protected/warehouses/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ProtectedRoute: typeof ProtectedRouteWithChildren
  PublicRoute: typeof PublicRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_public': {
      id: '/_public'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PublicRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_protected': {
      id: '/_protected'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof ProtectedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_public/login': {
      id: '/_public/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof PublicLoginRouteImport
      parentRoute: typeof PublicRoute
    }
    '/_protected/zones': {
      id: '/_protected/zones'
      path: '/zones'
      fullPath: '/zones'
      preLoaderRoute: typeof ProtectedZonesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/categories': {
      id: '/_protected/categories'
      path: '/categories'
      fullPath: '/categories'
      preLoaderRoute: typeof ProtectedCategoriesRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/warehouses/': {
      id: '/_protected/warehouses/'
      path: '/warehouses'
      fullPath: '/warehouses'
      preLoaderRoute: typeof ProtectedWarehousesIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/users/': {
      id: '/_protected/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof ProtectedUsersIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/suppliers/': {
      id: '/_protected/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers'
      preLoaderRoute: typeof ProtectedSuppliersIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/shipments/': {
      id: '/_protected/shipments/'
      path: '/shipments'
      fullPath: '/shipments'
      preLoaderRoute: typeof ProtectedShipmentsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/sells/': {
      id: '/_protected/sells/'
      path: '/sells'
      fullPath: '/sells'
      preLoaderRoute: typeof ProtectedSellsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/clients/': {
      id: '/_protected/clients/'
      path: '/clients'
      fullPath: '/clients'
      preLoaderRoute: typeof ProtectedClientsIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/buys/': {
      id: '/_protected/buys/'
      path: '/buys'
      fullPath: '/buys'
      preLoaderRoute: typeof ProtectedBuysIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/articles/': {
      id: '/_protected/articles/'
      path: '/articles'
      fullPath: '/articles'
      preLoaderRoute: typeof ProtectedArticlesIndexRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/warehouses/$id': {
      id: '/_protected/warehouses/$id'
      path: '/warehouses/$id'
      fullPath: '/warehouses/$id'
      preLoaderRoute: typeof ProtectedWarehousesIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/users/$id': {
      id: '/_protected/users/$id'
      path: '/users/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof ProtectedUsersIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/suppliers/$id': {
      id: '/_protected/suppliers/$id'
      path: '/suppliers/$id'
      fullPath: '/suppliers/$id'
      preLoaderRoute: typeof ProtectedSuppliersIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/shipments/create': {
      id: '/_protected/shipments/create'
      path: '/shipments/create'
      fullPath: '/shipments/create'
      preLoaderRoute: typeof ProtectedShipmentsCreateRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/shipments/$id': {
      id: '/_protected/shipments/$id'
      path: '/shipments/$id'
      fullPath: '/shipments/$id'
      preLoaderRoute: typeof ProtectedShipmentsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/sells/create': {
      id: '/_protected/sells/create'
      path: '/sells/create'
      fullPath: '/sells/create'
      preLoaderRoute: typeof ProtectedSellsCreateRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/sells/$id': {
      id: '/_protected/sells/$id'
      path: '/sells/$id'
      fullPath: '/sells/$id'
      preLoaderRoute: typeof ProtectedSellsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/clients/$id': {
      id: '/_protected/clients/$id'
      path: '/clients/$id'
      fullPath: '/clients/$id'
      preLoaderRoute: typeof ProtectedClientsIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/buys/create': {
      id: '/_protected/buys/create'
      path: '/buys/create'
      fullPath: '/buys/create'
      preLoaderRoute: typeof ProtectedBuysCreateRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/buys/$id': {
      id: '/_protected/buys/$id'
      path: '/buys/$id'
      fullPath: '/buys/$id'
      preLoaderRoute: typeof ProtectedBuysIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
    '/_protected/articles/$id': {
      id: '/_protected/articles/$id'
      path: '/articles/$id'
      fullPath: '/articles/$id'
      preLoaderRoute: typeof ProtectedArticlesIdRouteImport
      parentRoute: typeof ProtectedRoute
    }
  }
}

interface ProtectedRouteChildren {
  ProtectedCategoriesRoute: typeof ProtectedCategoriesRoute
  ProtectedZonesRoute: typeof ProtectedZonesRoute
  ProtectedArticlesIdRoute: typeof ProtectedArticlesIdRoute
  ProtectedBuysIdRoute: typeof ProtectedBuysIdRoute
  ProtectedBuysCreateRoute: typeof ProtectedBuysCreateRoute
  ProtectedClientsIdRoute: typeof ProtectedClientsIdRoute
  ProtectedSellsIdRoute: typeof ProtectedSellsIdRoute
  ProtectedSellsCreateRoute: typeof ProtectedSellsCreateRoute
  ProtectedShipmentsIdRoute: typeof ProtectedShipmentsIdRoute
  ProtectedShipmentsCreateRoute: typeof ProtectedShipmentsCreateRoute
  ProtectedSuppliersIdRoute: typeof ProtectedSuppliersIdRoute
  ProtectedUsersIdRoute: typeof ProtectedUsersIdRoute
  ProtectedWarehousesIdRoute: typeof ProtectedWarehousesIdRoute
  ProtectedArticlesIndexRoute: typeof ProtectedArticlesIndexRoute
  ProtectedBuysIndexRoute: typeof ProtectedBuysIndexRoute
  ProtectedClientsIndexRoute: typeof ProtectedClientsIndexRoute
  ProtectedSellsIndexRoute: typeof ProtectedSellsIndexRoute
  ProtectedShipmentsIndexRoute: typeof ProtectedShipmentsIndexRoute
  ProtectedSuppliersIndexRoute: typeof ProtectedSuppliersIndexRoute
  ProtectedUsersIndexRoute: typeof ProtectedUsersIndexRoute
  ProtectedWarehousesIndexRoute: typeof ProtectedWarehousesIndexRoute
}

const ProtectedRouteChildren: ProtectedRouteChildren = {
  ProtectedCategoriesRoute: ProtectedCategoriesRoute,
  ProtectedZonesRoute: ProtectedZonesRoute,
  ProtectedArticlesIdRoute: ProtectedArticlesIdRoute,
  ProtectedBuysIdRoute: ProtectedBuysIdRoute,
  ProtectedBuysCreateRoute: ProtectedBuysCreateRoute,
  ProtectedClientsIdRoute: ProtectedClientsIdRoute,
  ProtectedSellsIdRoute: ProtectedSellsIdRoute,
  ProtectedSellsCreateRoute: ProtectedSellsCreateRoute,
  ProtectedShipmentsIdRoute: ProtectedShipmentsIdRoute,
  ProtectedShipmentsCreateRoute: ProtectedShipmentsCreateRoute,
  ProtectedSuppliersIdRoute: ProtectedSuppliersIdRoute,
  ProtectedUsersIdRoute: ProtectedUsersIdRoute,
  ProtectedWarehousesIdRoute: ProtectedWarehousesIdRoute,
  ProtectedArticlesIndexRoute: ProtectedArticlesIndexRoute,
  ProtectedBuysIndexRoute: ProtectedBuysIndexRoute,
  ProtectedClientsIndexRoute: ProtectedClientsIndexRoute,
  ProtectedSellsIndexRoute: ProtectedSellsIndexRoute,
  ProtectedShipmentsIndexRoute: ProtectedShipmentsIndexRoute,
  ProtectedSuppliersIndexRoute: ProtectedSuppliersIndexRoute,
  ProtectedUsersIndexRoute: ProtectedUsersIndexRoute,
  ProtectedWarehousesIndexRoute: ProtectedWarehousesIndexRoute,
}

const ProtectedRouteWithChildren = ProtectedRoute._addFileChildren(
  ProtectedRouteChildren,
)

interface PublicRouteChildren {
  PublicLoginRoute: typeof PublicLoginRoute
}

const PublicRouteChildren: PublicRouteChildren = {
  PublicLoginRoute: PublicLoginRoute,
}

const PublicRouteWithChildren =
  PublicRoute._addFileChildren(PublicRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ProtectedRoute: ProtectedRouteWithChildren,
  PublicRoute: PublicRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
